module.exports = __webpack_public_path__ + "static/media/logomarca_padrao.bdf2ef95.png";